import type { RouteModel } from '@polaris/core/models'
import { useMemo } from 'react'

export function useFeesCategories(route: RouteModel) {
  const feeCategories = useMemo(() => {
    const feeBreakdown = route.FeeBreakdown
    const networkFees = feeBreakdown.filter((fee) => fee.is_network)
    const solanaAccountActivationFees = feeBreakdown.filter(
      (fee) =>
        fee.data.type.includes('solana-rent') ||
        fee.data.type.includes('cctp-account-creation'),
    )
    const solanaTokenActivationFees = feeBreakdown.filter((fee) =>
      fee.data.type.includes('solana-token-account'),
    )
    const polarisFees = feeBreakdown.filter((fee) => fee.polaris_fee)
    const otherFees = feeBreakdown.filter(
      (targetFee) =>
        networkFees.find((fee) => fee === targetFee) === undefined &&
        solanaAccountActivationFees.find((fee) => fee === targetFee) ===
          undefined &&
        solanaTokenActivationFees.find((fee) => fee === targetFee) ===
          undefined &&
        polarisFees.find((fee) => fee === targetFee) === undefined,
    )

    return {
      networkFees,
      solanaAccountActivationFees,
      solanaTokenActivationFees,
      polarisFees,
      otherFees,
    }
  }, [route.FeeBreakdown])

  return feeCategories
}
